<template>
  <div class="form-elements">
    <div class="row flex md12">
      <form>
        <va-card :title="$t('forms.inputs.title')">
          <div class="row">
            <va-input
              :class="isExpiredClass"
              label="Consent Title"
              :disabled="!canEdit"
              v-model="consent.consentTitle"
            ></va-input>

            <template v-if="canEdit">
              <va-select
                style="background:inherit"
                :class="isExpiredClass"
                label="Form Title"
                v-model="selectedFormId"
                keyBy="_id"
                textBy="formTitle"
                :options="forms"
              ></va-select>
            </template>
            <template v-else>
              <va-input
                label="Form Title"
                :class="isExpiredClass"
                :disabled="true"
                v-model="consent.formTitle"
              ></va-input>
            </template>

            <va-date-picker
              :class="isExpiredClass"
              :disabled="!canEdit"
              label="Created Date"
              :config="{dateFormat:'d/m/Y'}"
              v-model="consent.createdDate"
            />

            <transition name="fade" mode="out-in">
              <va-date-picker
                v-if="showExpirationDate"
                :class="isExpiredClass"
                label="Expiration Date"
                :config="{dateFormat:'d/m/Y'}"
                v-model="consent.expirationDate"
              />
            </transition>
          </div>

          <div class="flex">
            <va-input
              class="flex md12 xs12"
              label="Consent Question"
              type="textarea"
              :disabled="!canEdit"
              v-model="consent.consentQuestion"
            ></va-input>
          </div>

          <div class="row pull-right">
            <va-button color="danger">Back</va-button>
            <va-button v-if="canEdit" @click.prevent="showModal=true" color="warning">Close Consent</va-button>
            <va-button v-if="canEdit" @click.prevent="editConsent" color="success">Edit Consent</va-button>
          </div>
        </va-card>
      </form>
    </div>

    <!-- Close Modal Start -->
    <va-modal
      v-model="showModal"
      size="small"
      hideDefaultActions
      noOutsideDismiss
      title="Set Expiration Date"
      label="Expiration Date"
    >
      <va-date-picker
        label="Expiration Date"
        :config="{dateFormat:'d/m/Y'}"
        v-model="expirationDate"
      />

      <va-button style="margin-left: 17%" color="warning" @click="closeModal">Close Consent</va-button>
    </va-modal>
    <!-- Close Modal End -->
  </div>
</template>

<script>

export default {
  props: ["id"],
  data() {
    return {
      showModal: false,
      consent: {
        consentTitle: "",
        consentQuestion: "",
        formTitle: "",
        formId: "",
        createdDate: "",
        expirationDate: ""
      },
      expirationDate: "",
      selectedFormId: ""
    };
  },
  computed: {
    canEdit() {
      return true;
    },
    forms() {
      return this.$store.getters.forms;
    },
    isExpiredClass() {
      return {
        flex: true,
        xs12: true,
        md4: this.consent.expirationDate == "",
        md3: this.consent.expirationDate != ""
      };
    },
    showExpirationDate() {
      return this.consent.expirationDate != "";
    }
  },
  methods: {
    closeModal() {
      this.showModal = false;

      if (this.consent.createdDate < this.expirationDate) {
        this.consent.expirationDate = this.expirationDate;
      }
    },
    editConsent() {
      this.consent.formId = this.selectedFormId._id;
      if (this.canEdit) {
        this.$store.dispatch("editConsent", this.consent);
      }
    }
  },
  created() {
    //   this.consent = this.$store.getters.consent
    Object.assign(this.consent, this.$store.getters.consent);
    this.selectedFormId = this.consent.formTitle;
  }
};
</script>

<style scoped>
va-input {
  display: flex;
}

.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 1s;
}
.fade-leave {
}
.fade-leave-active {
  transition: opacity 1s;
  opacity: 0;
}
</style>
